// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-26380432]{align-items:center;background-image:linear-gradient(135deg,rgba(213,254,51,.08),rgba(142,163,59,.08));border-radius:1.125rem;display:flex;height:3rem;justify-content:center;margin:0 auto;position:relative;width:3rem}.icon[data-v-26380432]{color:rgb(var(--primary-color));height:1.75rem;width:1.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
